import type { User } from "firebase/auth";

export function isFullySignedIn(user: User | null | undefined): user is User {
  return Boolean(user && user.uid && !user.isAnonymous);
}

export const MUTATION_GATE_DEFAULT_COPY =
  "Create your free account to edit your proposal, generate technical plans, and save your progress.";

export function formatAuthActionError(error: unknown): string {
  const code = typeof (error as any)?.code === "string" ? (error as any).code : "";
  const message = typeof (error as any)?.message === "string" ? (error as any).message : "";
  if (code === "auth/email-already-in-use") {
    return "That email already has an account. Sign in with that email and password.";
  }
  if (code === "auth/invalid-email") {
    return "Please enter a valid email address.";
  }
  if (code === "auth/weak-password") {
    return "Use a stronger password (at least 6 characters).";
  }
  if (code === "auth/popup-closed-by-user") {
    return "Google sign-in was closed before finishing. Please try again.";
  }
  if (code === "auth/account-exists-with-different-credential") {
    return "An account for this email exists with a different sign-in method.";
  }
  if (code === "auth/wrong-password" || code === "auth/invalid-credential") {
    return "Incorrect password. Please try again.";
  }
  if (code === "auth/user-not-found") {
    return "No account found for that email.";
  }
  if (code === "auth/operation-not-allowed") {
    return "Google sign-in is not enabled for this Firebase Auth project (or Auth emulator). Enable the Google provider and try again.";
  }
  if (message.includes("CONFIGURATION_NOT_FOUND")) {
    return "Google sign-in is not configured for this Firebase project. Enable Google as a Sign-in provider in Firebase Authentication.";
  }
  return (error as Error)?.message || "Could not complete signup right now. Please try again.";
}
